/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

var markersArray = {everyMarkers: [], thirtyDaysMarkers: []};
var infosArray = {everyInfos: [], thirtyInfos: []};
var periodeObs = 'all';
var markersGroup = L.markerClusterGroup();
var savedMarkers = {everyMarkers: null, thirtyDaysMarkers: null};

function placeMarkers(stationsAffichees, jsonData, site) {
    markersGroup.removeLayers(markersGroup.getLayers());
    stationsAffichees = stationsAffichees ? stationsAffichees : 'all';
    var arrayMarker = [];
    var infos = [];
    var count = 0;
    var icons_path = location.href + 'wp-content/plugins/spn_csv_exporter/widgetVisualisateur/assets/' + site + '/icons/';
    var dateDuJour = new Date();
    var everyMarkersCheck = markersArray.everyMarkers.length ? true : false;
    var thirtyDaysMarkersCheck = markersArray.thirtyDaysMarkers.length ? true : false;

    dateDuJour.setMonth(dateDuJour.getMonth() - 1);

    var startCreate = new Date().getTime();
    for (var i = 0; i < jsonData.length; i++) {

        if (stationsAffichees === 'all' && !everyMarkersCheck) {
            markersGroup.addLayer(pushMarkers(markersGroup, infosArray.everyInfos, jsonData[i], icons_path, markersGroup));
            count++;
        }
        if (stationsAffichees === 'lastMonth' && !thirtyDaysMarkersCheck) {
            var dateTest = new Date();
            var date_object = formatDateFromString(jsonData[i].nom_station);
            dateTest.setDate(date_object.day);
            dateTest.setMonth(date_object.month - 1);
            dateTest.setYear(date_object.year);
            if (dateTest > dateDuJour) {
                markersGroup.addLayer(pushMarkers(markersGroup, infosArray.thirtyInfos, jsonData[i], icons_path, markersGroup));
                count++;
            }
        }
    }
    if (stationsAffichees === 'all' && !savedMarkers.everyMarkers) {
        arrayMarker = markersArray.everyMarkers;
        savedMarkers.everyMarkers = markersGroup.getLayers();
        infos = infosArray.everyInfos;
        type = true;
    }
    if (stationsAffichees === 'lastMonth' && !savedMarkers.thirtyDaysMarkers) {
        arrayMarker = markersArray.thirtyDaysMarkers;
        savedMarkers.thirtyDaysMarkers = markersGroup.getLayers();
        infos = infosArray.thirtyInfos;
        type = false;
    }
    void 0;
    var endCreate = new Date().getTime();
    var timeCreate = endCreate - startCreate;
    void 0;

    var startPlace = new Date().getTime();
    var endPlace = new Date().getTime();
    var timePlace = endPlace - startPlace;
    void 0;
    markersGroup.addTo(mymap);
    mymap.fitBounds(markersGroup.getBounds());
}

function formatDateFromString(string) {
    var date_unformated = string.substr(string.length - 14, 8);
    var day = date_unformated.substring(0, 2);
    var month = date_unformated.substring(2, 4);
    var year = date_unformated.substring(4, 8);
    var date_formated = {'fullDate': day + "/" + month + "/" + year, 'day': day, 'month': month, 'year': year};
    return date_formated;
}

function setIconAndStatut(statut, icons_path, commentaire) {
    var detObs = {};

    switch (statut) {
        case 'Validé':
            detObs.icon = icons_path + 'icon_valide.png';
            detObs.statut = statut;
            break;
        case 'Douteux' :
            detObs.icon = icons_path + 'icon_douteux.png';
            detObs.statut = statut;
            break;
        default:
            detObs.icon = icons_path + 'icon_verif.png';
            detObs.statut = 'En cours de validation';
    }
    detObs.commentaire = commentaire;
    return detObs;
}

function pushMarkers(markersGroup, infos, obs, icons_path) {
    var date_formated = '';
    var date_object = {};
    var participant = '';
    var toolTipGenerator;
    var tooltip;

    date_object = formatDateFromString(obs.nom_station);
    date_formated = date_object.fullDate;
    var detObs = setIconAndStatut(obs.validation, icons_path, obs.commentaires_validation);

    participant = getNameObs(obs);
    toolTipGenerator = getTooltip();
    toolTipGenerator.set(participant, date_formated, detObs);
    tooltip = toolTipGenerator.get();
    var coords = L.latLng(obs.loc_lat, obs.loc_long);

    var myIcon = L.icon({
        iconUrl: detObs.icon,
        iconSize: [40, 48]
    });
    var observation = L.marker(coords, {
        icon: myIcon,
        attribution: detObs.statut
    }).bindPopup(tooltip);
    observation.on('mouseover', function (e) {
            //open popup;
            this.openPopup();
        }).on('mouseout', function (e) {
            this.closePopup();
        });

    infos.push([tooltip]);
    return observation;
}

function getResults(periode, data, site, event) {
    if (periode) {
        periodeObs = periode;
        highlightTab(event.target, "button");
    } else {
        periode = periodeObs;
        highlightTab(event.target, "filtre");
    }
    placeMarkers(periode, data, site);
    periodeObs = periode;
}

function getPartialResults(type, event) {
    showMarkers(periodeObs, type);
    highlightTab(event.target, "filtre");
}

function highlightTab(tab, prefixe) {
    var allElements = document.getElementsByClassName(prefixe + "-selected");
    for (var i = 0; i < allElements.length; i++) {
        allElements[i].className = prefixe + "-unselected";
    }
    tab.className = prefixe + "-selected";
}

function getNameObs(obs) {
    var espaceSep = obs.observateur.lastIndexOf(' ');
    var participant = '';
    if (espaceSep === -1) {
        participant = obs.observateur;
    } else {
        if (!obs.nom) {
            var nom_mod = obs.observateur.substr(0, espaceSep);
            var prenom_mod = obs.observateur.substr(espaceSep + 1);
            participant = nom_mod.toUpperCase() + ' ' + upperFirstChar(prenom_mod);
        } else {
            participant = obs.nom.toUpperCase() + ' ' + upperFirstChar(obs.prenom);
        }
    }
    return participant;
}

function autoCompleteFormater(data) {
    getNameObs(data);
}

function showMarkers(typeArrayGM, typeToShow) {
    var layers = null;
    if(typeArrayGM === 'all') {
        layers = savedMarkers.everyMarkers;
    } else if(typeArrayGM === 'lastMonth') {
        layers = savedMarkers.thirtyDaysMarkers;
    }
    var tempGroup = L.markerClusterGroup();
    layers.map(function(marker) {
       if(marker.options.attribution === typeToShow) {
           tempGroup.addLayer(marker);
       }
    });
    markersGroup.removeLayers(markersGroup.getLayers());
    markersGroup = tempGroup;
    markersGroup.removeFrom(mymap);
    markersGroup.addTo(mymap);
}